import React from 'react';
//import {Link} from 'react-dom';
//import { TEXT, urlCreator } from '../Common.js';

class Item extends React.Component{


    constructor(props) {
        super(props);
        this.state = {
            imageLoaded: false
        };
    }




    handleImageLoaded() {
        this.setState({ imageLoaded: true});
    }


    handleImageErrored(err) {
        console.log('Image load error', err);
    }


    openLink =(evt)=>{

            if(this.props.item.type !== 'vr_games'){
                evt.preventDefault();
                this.props.onItemSelect(this.props.item);
            }
    }


    render(){
        //console.log(this.props.item);
    
        let url = (this.props.item.type === 'vr_games' ? '/play/gueff/#' + this.props.item.slug + '/' + this.props.item.id : this.props.item.link);

        return(
            <div id={"list-item-" + this.props.item.id} className={"col-12 col-lg-4 content-list-item" + (!this.state.imageLoaded ? ' esd-loading' : '') + (this.props.selected ? ' content-list-item-selected' : '')}>
                <figure>
                    <a onClick={this.openLink} href={url} target="_blank" rel="noopener noreferrer" title={this.props.item.title.rendered}>
                        <img 
                        className="img-fluid" 
                        src={(this.props.item.vr_image_object ? this.props.item.vr_image_object.vr_image_small[0] : this.props.item._embedded['wp:featuredmedia'][0].media_details.sizes.vr_image_medium.source_url)} 
                        alt={this.props.item.title.rendered}
                        onLoad={this.handleImageLoaded.bind(this)}
                        onError={this.handleImageErrored.bind(this)}
                        />
                        {(this.props.item.acf.vr_game_type ? <span className="list-item-tag">{this.props.item.acf.vr_game_type}</span> : '')}
                    </a>
                </figure>
                <h3>
                    <a onClick={this.openLink} href={url} target="_blank" rel="noopener noreferrer" title={this.props.item.title.rendered}>{this.props.item.title.rendered}</a>
                </h3>
            </div>
        )
    }
}


export default Item;